import { render, staticRenderFns } from "./KPITreballador.vue?vue&type=template&id=48d08556&"
import script from "./KPITreballador.vue?vue&type=script&lang=js&"
export * from "./KPITreballador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports